export const ROLES = {
  user: "user",
  sales: "sales",
  admin: "admin",
  owner: "owner",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const ROLE_LEVELS: Record<string, number> = {
  user: 1,
  sales: 2,
  admin: 3,
  owner: 4,
};

export const hasRole = (userRole: string | undefined, requiredRole: string): boolean => {
  return (ROLE_LEVELS[userRole ?? ""] ?? 0) >= (ROLE_LEVELS[requiredRole] ?? 0);
};
